import React from "react";
import { toast } from "sonner";
import { Copy, Clock, MapPin, Timer, Phone } from "lucide-react";
import { MY_OFFERS } from "../demoData";
import { Card, PageTitle, Badge } from "../ui";

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-2 text-xs">
    <Icon className="w-3.5 h-3.5 text-slate-500 mt-0.5 flex-shrink-0" />
    <span className="text-slate-500 w-14 flex-shrink-0">{label}</span>
    <span className="text-slate-200">{value}</span>
  </div>
);

export default function MyOffers() {
  const copy = (did) => {
    navigator.clipboard?.writeText(did).catch(() => {});
    toast.success(`Tracking number ${did} copied`);
  };
  return (
    <>
      <PageTitle title="My Offers" sub="Campaigns you are approved to run. Use the tracking number in your ads." />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {MY_OFFERS.map((o) => (
          <Card key={o.id} className="overflow-hidden" testId={`my-offer-${o.id}`}>
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-5 py-4 flex items-start justify-between gap-3">
              <div>
                <p className="text-[11px] text-white/70">{o.id} · {o.vertical}</p>
                <p className="font-semibold text-white leading-snug">{o.name}</p>
              </div>
              <Badge>{o.status}</Badge>
            </div>
            <div className="p-5 space-y-2.5">
              <p className="text-3xl font-extrabold text-white">${o.payout}<span className="text-sm font-medium text-slate-400"> / qualified call</span></p>
              <Row icon={Timer} label="Buffer" value={`${o.buffer} post-IVR`} />
              <Row icon={Clock} label="Hours" value={o.hours} />
              <Row icon={MapPin} label="States" value={o.states} />
              <div className="mt-3 flex items-center justify-between gap-2 rounded-xl bg-[#0b0f15] border border-slate-800 px-3.5 py-2.5">
                <span className="flex items-center gap-2 text-sm font-mono text-blue-300"><Phone className="w-3.5 h-3.5" />{o.did}</span>
                <button onClick={() => copy(o.did)} className="text-slate-400 hover:text-white" data-testid={`copy-did-${o.id}`}><Copy className="w-4 h-4" /></button>
              </div>
              <p className="text-xs text-slate-500">{o.calls.toLocaleString()} calls delivered this month</p>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
